import { DashboardCard } from "@dashboard/components/Card";
import { WarehouseErrorFragment } from "@dashboard/graphql";
import { FormChange } from "@dashboard/hooks/useForm";
import { commonMessages } from "@dashboard/intl";
import { getFormErrors } from "@dashboard/utils/errors";
import getWarehouseErrorMessage from "@dashboard/utils/errors/warehouse";
import { TextField } from "@material-ui/core";
import React from "react";
import { useIntl } from "react-intl";

export interface WarehouseInfoProps {
  data: Record<"name" | "email" | "longitude" | "latitude" | "siteLink", string>;
  disabled: boolean;
  errors: WarehouseErrorFragment[];
  onChange: FormChange;
}

const WarehouseInfo = ({ data, disabled, errors, onChange }: WarehouseInfoProps) => {
  const intl = useIntl();
  const formErrors = getFormErrors(["name", "email"], errors);

  return (
    <DashboardCard data-test-id="general-information-section" paddingTop={9}>
      <DashboardCard.Header>
        <DashboardCard.Title>
          {intl.formatMessage(commonMessages.generalInformations)}
        </DashboardCard.Title>
      </DashboardCard.Header>
      <DashboardCard.Content>
        <TextField
          data-test-id="warehouse-name-input"
          disabled={disabled}
          error={!!formErrors.name}
          fullWidth
          helperText={getWarehouseErrorMessage(formErrors.name, intl)}
          label={intl.formatMessage({
            id: "llBnr+",
            defaultMessage: "Warehouse Name",
          })}
          name={"name" as keyof typeof data}
          value={data.name}
          onChange={onChange}
          required
          InputProps={{
            inputProps: {
              autoComplete: "none",
            },
          }}
        />
        <TextField
          data-test-id="warehouse-email-input"
          disabled={disabled}
          error={!!formErrors.email}
          fullWidth
          helperText={getWarehouseErrorMessage(formErrors.email, intl)}
          label={intl.formatMessage({
            id: 'sy+pv5',
            defaultMessage: "Email",
          })}
          name={"email" as keyof typeof data}
          value={data.email}
          onChange={onChange}
          required
          type="email"
          InputProps={{
            inputProps: {
              autoComplete: "email",
            },
          }}
          style={{ marginTop: 16 }}
        />
        <TextField
          data-test-id="warehouse-longitude-input"
          disabled={disabled}
          fullWidth
          label={intl.formatMessage({
            id: 'bbPfn0',
            defaultMessage: "Longitude",
          })}
          name={"longitude" as keyof typeof data}
          value={data.longitude}
          onChange={onChange}
          required
          type="number"
          InputProps={{
            inputProps: {
              step: "any",
              autoComplete: "none",
            },
          }}
          style={{ marginTop: 16 }}
        />
        <TextField
          data-test-id="warehouse-latitude-input"
          disabled={disabled}
          fullWidth
          label={intl.formatMessage({
            id: 'ujYGO/',
            defaultMessage: "Latitude",
          })}
          name={"latitude" as keyof typeof data}
          value={data.latitude}
          onChange={onChange}
          required
          type="number"
          InputProps={{
            inputProps: {
              step: "any",
              autoComplete: "none",
            },
          }}
          style={{ marginTop: 16 }}
        />
        <TextField
          data-test-id="warehouse-site-link-input"
          disabled={disabled}
          fullWidth
          label={intl.formatMessage({
            id: '3Da/+i',
            defaultMessage: "Site Link",
          })}
          name={"siteLink" as keyof typeof data}
          value={data.siteLink}
          onChange={onChange}
          required
          type="url"
          InputProps={{
            inputProps: {
              autoComplete: "url",
            },
          }}
          style={{ marginTop: 16 }}
        />
      </DashboardCard.Content>
    </DashboardCard>
  );
};

WarehouseInfo.displayName = "WarehouseInfo";
export default WarehouseInfo;
